import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { X, Check, Crown } from 'lucide-react';

const PAYMENT_LINKS = {
  monthly: 'https://buy.stripe.com/4gMaEX62y94r2o6cUMdwc00',
  yearly: 'https://buy.stripe.com/28EaEX9eK3K7geW9IAdwc01'
};

const UpgradeModal = ({ onClose }) => {
  const { user } = useAuth();
  const [selectedPlan, setSelectedPlan] = useState('yearly');

  const handleSubscribe = () => {
    // Ouvrir Stripe avec l'email pré-rempli
    const paymentUrl = `${PAYMENT_LINKS[selectedPlan]}?prefilled_email=${encodeURIComponent(user?.email || '')}`;
    window.open(paymentUrl, '_blank');
    onClose();
  };

  const benefits = [
    'Échanges illimités avec Louis',
    'Historique de conversation sauvegardé',
    'Recettes personnalisées selon vos objectifs',
    'Conseils nutrition sur mesure',
    'Suivi de progression',
    'Support prioritaire'
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={e => e.stopPropagation()}>
        <div className="upgrade-header">
          <button className="upgrade-close" onClick={onClose}>
            <X size={16} />
          </button>
          <Crown size={28} style={{ marginBottom: 6 }} />
          <h2>Passez en Pro</h2>
          <p>Débloquez tout le potentiel de votre coach nutrition</p>
        </div>

        <div className="upgrade-content">
          <div className="trial-banner">
            <div className="trial-icon">🎁</div>
            <h3>7 jours d'essai gratuit</h3>
            <p>Testez gratuitement, vous serez débité après 7 jours</p>
          </div>

          <div className="benefits-list">
            <h4>Inclus dans MonCoach Pro :</h4>
            {benefits.map((benefit, i) => (
              <div key={i} className="benefit-item">
                <Check size={14} />
                <span>{benefit}</span>
              </div>
            ))}
          </div>

          <div className="pricing-cards">
            <div 
              className={`pricing-card ${selectedPlan === 'monthly' ? 'selected' : ''}`}
              onClick={() => setSelectedPlan('monthly')}
            >
              <div className="pricing-period">Mensuel</div>
              <div className="pricing-amount">
                8,99€<span>/mois</span>
              </div>
            </div>

            <div 
              className={`pricing-card popular ${selectedPlan === 'yearly' ? 'selected' : ''}`}
              onClick={() => setSelectedPlan('yearly')}
            >
              <div className="pricing-period">Annuel</div>
              <div className="pricing-amount">
                54,99€<span>/an</span>
              </div>
              <div className="pricing-yearly-note">
                Soit 4,58€/mois
              </div>
            </div>
          </div>

          <button className="upgrade-cta" onClick={handleSubscribe}>
            Commencer mes 7 jours gratuits
          </button>

          <button className="upgrade-skip" onClick={onClose}>
            Plus tard
          </button>

          <div className="upgrade-footer">
            <p>💳 Paiement sécurisé • Annulez quand vous voulez • Essai 100% gratuit</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
